import { Button } from '../../../components/button'

export default function ResendEmailConfirmation({ onResend, email }) {
  return (
    <div className='wrapper'>
      <h2 className='title'>Check your email!</h2>
      <p className='confirmation'>
        We have sent a confirmation to
        <br />
        <span className='email'>{email}</span>
      </p>

      <div className='flex flexDirectionColumn alignCenter'>
        <p className='description '>
          Please follow the link within the email to confirm your account and continue.
        </p>
        <Button className='confirm' onClick={onResend}>
          Resend Email
        </Button>
      </div>

      <style jsx>{`
        .title {
          padding: 0 0 0.8rem;
          line-height: 3.6rem;
          font-size: 3.2rem;
        }

        .confirmation {
          margin: 0.7rem auto 2.6rem;
          text-align: center;
          font-size: 1.6rem;

          .email {
            color: var(--text-link-color);
            margin: 2.6rem;
            word-wrap: break-word;
          }
        }

        .description {
          max-width: 26.6rem;
          margin: 0.7rem auto 2.6rem;
          text-align: center;
          font-size: 1.6rem;
        }

        .wrapper {
          position: relative;
          min-width: 43.6rem;
          max-width: 90rem;
          padding: 2.6rem 2rem 4.1rem;
          background: #fff;
          border-radius: 1rem;
          text-align: center;
        }

        @media (max-width: 1024px) {
          .wrapper {
            width: 100%;
            padding: 1.6rem 2rem 4.1rem;
          }

          :global(.confirm) {
            position: fixed;
            width: calc(100% - 2.8rem);
            bottom: 2.1rem;
          }
        }
      `}</style>
    </div>
  )
}
